// Lib
import { reactionsConfig } from '@/lib/analytics/kpis/pinterest/reactions';
import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const mediaViewerReactionsConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> = {
    ...reactionsConfig,
    size: SIZE_50,
    tooltip: null,
    loader: MediaViewerKpiLoader
};
